// extracted by mini-css-extract-plugin
export default {"filterChip":"filter-chips_filterChip__gdye1"};